// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.force-logout[data-v-2b7e7af6] {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
